import React from 'react';
import Navigation from 'Components/Navigation';

class PasswordChangedPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {

        return (
            <div>
                <Navigation authenticatedUser={this.props.authenticatedUser} />
                <div className="padding-tb10" />
                <div className="container-fluid padding-lr55">
                    <div className="row">
                        <div className="col-lg-12">
                            <p>
                                Password successfully changed. Please use your new password next time you log in.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            );
    }
}

export { PasswordChangedPage };